export var Direction;
(function (Direction) {
    Direction["Up"] = "up";
    Direction["Down"] = "down";
    Direction["Left"] = "left";
    Direction["Right"] = "right";
})(Direction || (Direction = {}));
export var Position;
(function (Position) {
    Position["TopRight"] = "top-right";
    Position["TopLeft"] = "top-left";
    Position["BottomRight"] = "bottom-right";
    Position["BottomLeft"] = "bottom-left";
})(Position || (Position = {}));
export var NotificationType;
(function (NotificationType) {
    NotificationType["Info"] = "info";
    NotificationType["Success"] = "success";
    NotificationType["Warning"] = "warning";
    NotificationType["Error"] = "error";
})(NotificationType || (NotificationType = {}));
